import { AdminStore } from "./components";
import { BrowserRouter, Routes, Route } from "react-router-dom";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<AdminStore />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
